/**
 * Hand a fetched file to the browser.
 *
 * The object URL is revoked afterwards: without it every export leaks the
 * whole file until the tab is closed, and these are exports somebody runs
 * repeatedly while narrowing a date range.
 */
export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
